import {AuditItemTypeTitle} from "../../Models/Audit/AuditConstants";

export const auditsFilterMap = {
    area: AuditItemTypeTitle.AREAS,
    issue: AuditItemTypeTitle.PINS,
    line: AuditItemTypeTitle.LINES,
};

export const baseColorOptions = [
    {id: "#FF6B5B", color_code: "#FF6B5B"},
    {id: "#FFA726", color_code: "#FFA726"},
    {id: "#2ECC71", color_code: "#2ECC71"},
    {id: "#7ED6DF", color_code: "#7ED6DF"},
    {id: "#3498DB", color_code: "#3498DB"},
    {id: "#FF79C6", color_code: "#FF79C6"},
    {id: "#E056FD", color_code: "#E056FD"},
    {id: "#FF3131", color_code: "#FF3131"},
];
